export const getEntityFabButtonStyles = () => ({
  fabButton: {
    position: 'fixed',
    bottom: 16,
    right: 16,
    animations: {
      fabTimeout: 500,
      fadeTransition: 'opacity 0.3s ease'
    }
  },
});